<!-- Liste des configurations SBT -->
<ng-container *ngIf="listeSbtConfig; else loading">
    <list-view [liste]="listeSbtConfig"></list-view>
    <floating-button [listeActions]="listeActions"></floating-button>
</ng-container>

<!-- Écran de chargement -->
<ng-template #loading>
    <please-wait class="content"></please-wait>
</ng-template>